import { render, staticRenderFns } from "./Downloaded.vue?vue&type=template&id=2a449387&"
import script from "./Downloaded.vue?vue&type=script&lang=js&"
export * from "./Downloaded.vue?vue&type=script&lang=js&"
import style0 from "./Downloaded.vue?vue&type=style&index=0&id=2a449387&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports